import { Injectable } from '@angular/core';
import { BaseApiService } from './base-api.service';
import { WorkitemDefinitionItem } from '../../models/workitem-definition-item.model';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WorkitemDefinitionService extends BaseApiService<WorkitemDefinitionItem> {
  private readonly definitionCountRefreshSubject = new Subject<void>();
  readonly definitionCountRefreshRequested$ = this.definitionCountRefreshSubject.asObservable();

  constructor() {
    super('/workitem-definitions');
  }

  requestDefinitionCountRefresh(): void {
    this.definitionCountRefreshSubject.next();
  }
}
